import React from "react";

export const Logo = () => {
  return <img height={28} src={"/images/logos/fnl-logo.png"} alt={"Логотип"} />;
};
